import AdmTareaService from "@/api/services/tarea/AdmTareaService"
import Vue from "vue"

const state = () => ({
    tareas: [],
    pagination: {
        descending: false,
        page: 1,
        rowsPerPage: 10,
        sortBy: "fecha_creacion",
        rowsPerPageItems: [5, 10, 20, 30, 40, 50]
    }
})

const getters = {
    TAREAS: state => {
        return state.tareas
    },
    TAREAS_PAG: state => {
        return state.pagination
    }
}

const mutations = {
    SET_TAREAS: (state, payload) => {
        state.tareas = payload
    },

    SET_TAREAS_PAG: (state, payload) => {
        state.pagination = payload
    },

    ADD_TAREA: (state, payload) => {
        state.tareas.push(payload)
    },

    UPDATE_TAREA: (state, payload) => {
        state.tareas = state.tareas.map(el => (el.id === payload.id ? payload : el))
    },

    DELETE_TAREA: (state, payload) => {
        state.tareas = state.tareas.filter(el => el.id !== payload.id)
    }
}

const actions = {
    LOAD_TAREAS: async ({ commit, state }, { filter, tareaEstado, customfilter }) => {
        try {
            let pagination = {
                page: state.pagination.page,
                rowsPerPage: state.pagination.rowsPerPage,
                sortBy: state.pagination.descending ? "-" + state.pagination.sortBy : state.pagination.sortBy
            }

            if (tareaEstado === "5") {
                customfilter = `fecha_creacion=${new Date().toISOString().substr(0, 10)}`
            }

            if (tareaEstado === "7") {
                customfilter = `fecha_cumplimiento=${new Date().toISOString().substr(0, 10)}`
            }

            if (tareaEstado === "8") {
                customfilter = `estado=2&fecha_cumplimiento=${new Date().toISOString().substr(0, 10)}`
            }

            let { data, status, headers } = await AdmTareaService.get({ filter, customfilter, tareaEstado, ...pagination })
            if (status === 200) {
                commit("SET_TAREAS", data)
                return parseInt(headers["x-pagination-total-count"])
            }
        } catch (error) {
            Vue.notify({
                group: "pages",
                type: "error",
                title: "Servidor",
                text: "No se han podido cargar las tareas, inténtelo nuevamente"
            })
        }
    },

    LOAD_ALL_TAREAS: async ({ commit }) => {
        try {
            let { data, status } = await AdmTareaService.getAll()
            if (status === 200) {
                commit("SET_TAREAS", data)
                return data
            }
        } catch (error) {
            if (error.response) {
                Vue.notify({
                    group: "pages",
                    type: "error",
                    title: "Servidor",
                    text: "No se ha podido realizar la acción"
                })
                return { data: error.response.data, status: error.response.status }
            }
        }
    },

    LOAD_ALL_RECORDS_TAREAS: async ({ commit }) => {
        try {
            let { data, status } = await AdmTareaService.getAllRecords()
            if (status === 200) {
                commit("SET_TAREAS", data)
                return null
            }
        } catch (error) {
            Vue.notify({
                group: "pages",
                type: "error",
                title: "Servidor",
                text: "No se han podido cargar las tareas, inténtelo nuevamente"
            })
        }
    },

    ADD_TAREA: async ({ commit }, payload) => {
        try {
            let { data, status } = await AdmTareaService.post(payload)
            if (status === 201) {
                commit("ADD_TAREA", data)
                Vue.notify({
                    group: "pages",
                    type: "success",
                    title: "Agregando",
                    text: "La tarea ha sido agregada satisfactoriamente"
                })
            }
            return null
        } catch (error) {
            if (!error.response) {
                Vue.notify({
                    group: "pages",
                    type: "error",
                    title: "Servidor",
                    text: "No se ha podido agregar la tarea, inténtelo nuevamente"
                })
            } else {
                return { data: error.response.data, status: error.response.status }
            }
        }
    },

    UPDATE_TAREA: async ({ commit }, payload) => {
        try {
            let { data, status } = await AdmTareaService.put(payload)
            if (status === 200) {
                commit("UPDATE_TAREA", data)
                Vue.notify({
                    group: "pages",
                    type: "success",
                    title: "Modificando",
                    text: "La tarea ha sido modificada satisfactoriamente"
                })
            }
            return null
        } catch (error) {
            if (!error.response) {
                Vue.notify({
                    group: "pages",
                    type: "error",
                    title: "Servidor",
                    text: "No se ha podido modificar la tarea, inténtelo nuevamente"
                })
            } else {
                return { data: error.response.data, status: error.response.status }
            }
        }
    },

    TOOGLE_STATUS_TAREA: async ({ commit }, payload) => {
        try {
            let { data, status } = await AdmTareaService.toogle_status(payload)
            if (status === 200) {
                Vue.notify({
                    group: "pages",
                    type: "success",
                    title: "Modificando",
                    text: "Se ha modificado satisfactoriamente el estado de la tarea"
                })
                return data
            }
            return null
        } catch (error) {
            if (!error.response) {
                Vue.notify({
                    group: "pages",
                    type: "error",
                    title: "Servidor",
                    text: "No se ha podido modificar el estado de la tarea, inténtelo nuevamente"
                })
            }
        }
    },

    DELETE_TAREA: async ({ commit }, payload) => {
        try {
            let { status, data } = await AdmTareaService.delete(payload)
            if (status === 204) {
                commit("DELETE_TAREA", payload)
                Vue.notify({
                    group: "pages",
                    type: "success",
                    title: "Eliminando",
                    text: "La tarea ha sido eliminada satisfactoriamente"
                })
            }
            if (status === 200) {
                commit("UPDATE_TAREA", data)
                Vue.notify({
                    group: "pages",
                    type: "success",
                    title: "Deshabilitando",
                    text: "La tarea ha sido archivada satisfactoriamente"
                })
            }
        } catch (error) {
            Vue.notify({
                group: "pages",
                type: "error",
                title: "Servidor",
                text: "No se ha podido eliminar/deshabilitar la tarea, inténtelo nuevamente"
            })
        }
    }
}

export default {
    state,
    getters,
    mutations,
    actions
}
